import styled from 'styled-components'

export const ConfigHeaderFilterContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
    position: relative;

    .label {
        color: ${({ theme }) => theme['gray-800']};
    }

    .configheaderfilter-clickable {
        height: 27px;
        width: 92px;
        border-radius: 3px;
        border: 1px solid ${({ theme }) => theme['gray-400']};
        display: flex;
        gap: 6px;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        padding-left: 8px;
        i {
            color: ${({ theme }) => theme['blue-500']};
            font-weight: 900;
        }
    }

    .configheaderfilter-clickable:hover {
        cursor: pointer;
    }
`

export const ConfigHeaderFilterDropdown = styled.div`
    /* padding: 16px 16px 8px 16px; */
    padding: 16px;
    background: ${({ theme }) => theme['gray-0']};
    border: 1px solid ${({ theme }) => theme['gray-400']};
    border-radius: 3px;
    width: 220px;
    position: absolute;
    top: calc(100%);
    right: 0px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .Select-menu {
        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: var(--gray-600);
            border-radius: 10px;
        }
    }
    .menu-item {
        display: flex;
    }
`

export const SaveBar = styled.div`
    padding: 8px 0 0 0;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    display: flex;
    /* margin-top: 8px; */
`

export const SaveButton = styled.button`
    border: 1px solid;
    border-color: ${({ theme }) => theme['blue-500']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-500']};
    padding: 4px 16px;
`

export const CancelButton = styled.button`
    text-transform: capitalize;
    border: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-800']};
    background: transparent;
    margin-left: 8px;
    padding: 4px 16px;
`
